import React from 'react';
import './App.css';
import Home from './containers/Home';

const App = () => {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
